import { render, staticRenderFns } from "./PaxTable.vue?vue&type=template&id=52bc654f&scoped=true&"
import script from "./PaxTable.vue?vue&type=script&lang=js&"
export * from "./PaxTable.vue?vue&type=script&lang=js&"
import style0 from "./PaxTable.vue?vue&type=style&index=0&id=52bc654f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc654f",
  null
  
)

export default component.exports